export default [
    {
        path: '/itinerary-categories',
        name: 'itinerary-categories',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/ItineraryCategories.vue')
    }
]
